import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class PackTypeReferenceService extends BaseReferenceService {
  constructor() {
    super('PackTypeReference');
  }
}
